import { render, staticRenderFns } from "./course-detail.vue?vue&type=template&id=4fa8ee8a&scoped=true&"
import script from "./course-detail.vue?vue&type=script&lang=js&"
export * from "./course-detail.vue?vue&type=script&lang=js&"
import style0 from "./course-detail.scss?vue&type=style&index=0&id=4fa8ee8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa8ee8a",
  null
  
)

export default component.exports